


























































import Vue from 'vue';
import shopOrdercall from '../../../shop.ordecall'

export default Vue.extend({
  data() {
    return {
      shopOrdercall: shopOrdercall,
    }
  },
  methods: {
    getPluginVersion(): any {
      return this.shopOrdercall.pluginVersion;
    },
    getPluginUrl(): any {
      return this.shopOrdercall.pluginUrl;
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/header/MainHeader.vue